import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { getGeneralStatistics } from "~/data/dashboard/dashboard.service";

import { useUser } from "../shared/queries/user-query";

const statisticsQuery = queryOptions({
  queryKey: ["general_statistics"],
  queryFn: getGeneralStatistics,
});

export function StatisticsSection() {
  const { data } = useSuspenseQuery(statisticsQuery);
  const user = useUser();

  return (
    <div className="flex-1 rounded-[20px] bg-white shadow-card p-5">
      <div className="flex items-center gap-3 mb-[10px]">
        <h3 className="text-[#2D2D2D] font-alternative font-semibold text-2xl uppercase">
          Estatísticas
        </h3>
        <div className="text-sm font-alternative bg-[#D3D3D3] text-[#5B5B5B] px-2 rounded h-5 flex justify-center items-center">
          {data.total_stations}{" "}
          {data.total_stations > 1 ? "estações realizadas" : "estação realizada"}
        </div>
      </div>

      <ol className="grid gap-[10px] overflow-y-auto" style={{ height: 302 }}>
        {data.statistics.map((it, i) => (
          <li
            key={it.name}
            className="mr-5 font-alternative flex items-center gap-10 rounded-[10px] px-6 py-[10px] bg-surface"
          >
            <span
              data-index={i}
              className="px-2 text-sm leading-4 data-[index=0]:text-primary-1 data-[index=1]:text-primary-2 data-[index=2]:text-alternative-2 data-[index=3]:text-alternative-1 data-[index=4]:text-secondary-2 data-[index=5]:text-secondary-1"
            >
              {it.name}
            </span>
            <div className="text-center px-2 ml-auto">
              <span className="block text-lg leading-6 font-medium">
                {it.quantity}
              </span>
              <span className="text-sm leading-4">Tentativas</span>
            </div>
            <div className="text-center px-2">
              <span
                data-bad={it.avg_score < user.cutoff_score}
                className="block text-lg leading-6 font-medium text-alternative-2 data-[bad=true]:text-red-500"
              >
                {it.avg_score.toFixed(1)}
              </span>
              <span className="text-sm leading-4 truncate">Sua média</span>
            </div>
            <div className="text-center px-2">
              <span className="block text-lg leading-6 font-medium text-primary-1">
                {it.application_avg_score.toFixed(1)}
              </span>
              <span className="text-sm leading-4 truncate">Média geral</span>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
